var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type == 'METABIOME')?[_c('metabiome',{attrs:{"sampleIdentifier":_vm.primarySample.identifier,"hideHeader":_vm.hideHeader,"hideName":_vm.hideName,"exportURL":_vm.exportURL}})]:[_c('single',{attrs:{"primarySample":_vm.primarySample,"secondarySample":_vm.secondarySample,"hideHeader":_vm.hideHeader,"hideName":_vm.hideName,"exportURL":_vm.exportURL}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-341428e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@microbadevs/report/src/App.vue
// module id = ZIhA
// module chunks = 1